import { CtaBanner, CtaTheme } from "@hub/ui/ads/cta-banner";
import React from "react";
import { DEV_CENTER_AUTH0_SIGNUP_URL } from "@hub/services/content/data/content-values";

export const ReadyToSecureAd: React.FC = () => {
  return (
    <CtaBanner
      title="Ready to secure your apps?"
      description={[
        "Get Auth0 for free with up to 7,500 active users and unlimited logins.",
        "No credit card required.",
      ]}
      theme={CtaTheme.BLACK}
      primaryAction={{
        label: "Start Building",
        url: DEV_CENTER_AUTH0_SIGNUP_URL,
      }}
      secondaryAction={{
        label: "Pricing",
        url: "https://auth0.com/pricing",
      }}
    />
  );
};
